import { render, staticRenderFns } from "./relatorioGeral.vue?vue&type=template&id=31957eb5"
import script from "./relatorioGeral.vue?vue&type=script&lang=js"
export * from "./relatorioGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports